import { useMutation } from "react-query";
import { request } from "utils/axios-utils";

export const useCustomMutation = (
  requestObj = { url: "", method: "post", data: {} },
  queryObj = {}
) => {
  return useMutation({
    mutationFn: async (mutationData) => {
      const isReactEvent = mutationData?._reactName; // Detects React synthetic events

      const dataToSend =
        requestObj.data ||
        (!mutationData || isReactEvent ? null : mutationData); //this is used to check if data is passed through the mutation function when called or through the request object when called

      return await request({
        ...requestObj,
        data: dataToSend,
        avoidCancelling: true,
      });
    },
    ...queryObj,
  });
};
